var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen"},[(_vm.w >= 800)?_c('index-pc'):_c('index-mp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }